/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, Input} from '@angular/core';

import {IxModule} from '@siemens/ix-angular';
import {flagAssetPath} from '../../utils/flag-asset.util';

@Component({
  selector: 'app-language',
  imports: [IxModule],
  templateUrl: './language.component.html',
  styleUrl: './language.component.scss',
})
export class LanguageComponent {
  @Input({required: true}) attributeValue!: any;
  @Input({required: true}) valuePath!: string;

  get languageCode(): string {
    return this.valuePath.split('.').at(-1) ?? '';
  }

  getIcon(): string | null {
    return flagAssetPath(this.languageCode.toLowerCase());
  }
}
